import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f773a8b0"
import script from "./Voucher.vue?vue&type=script&lang=js"
export * from "./Voucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports